module.exports = __webpack_public_path__ + "static/media/2025학년도 졸업앨범 주요 내용 안내 가정통신문.f764e404.pdf";